import React, { useState, useEffect } from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";

const Addmembership = ({handleClose}) => {
  const [inputField, setInputField] = useState({ months: "", price: "" });
  const [membership, setMembership] = useState([]);

const handleOnChange = (event, name)=>{
  setInputField({...inputField, [name]:event.target.value})
}


const fetchMembership = async()=>{
await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/plans/get-membership`,{withCredentials:true}).then((response)=>{
setMembership(response.data.membership)
// toast.success(response.data.membership.length +"membership fetched");
}).catch(err=>{
toast.error("Something Wrong Happened");
})
}


useEffect(()=>{
  fetchMembership();
},[])

const handleAdMembership = async()=>{
await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/plans/add-membership`,inputField,{withCredentials:true}).then((response)=>{
toast.success(response.data.message);
handleClose();
}).catch(err=>{
toast.error("Something Wrong Happened");
})
}


const handleDeleteMembership = async (id) => {
  try {
    await axios.delete(`${process.env.REACT_APP_FRONTEND_URL}/plans/delete-membership/${id}`, {
      withCredentials: true,
    });

    toast.success("Deleted Successfully");

    // UI update without reload 🔥
    setMembership(membership.filter((item) => item._id !== id));

  } catch (err) {
    toast.error("Something Wrong Happened");
  }
};

  return (
    <div className="">
      <div className=" membership1">
      {
        membership.map((item, index)=>{
          return(
        <div className="membership2">
          <div>{item.months} Months Membership</div>
          <div style={{ display: "flex", textAlign: "center" }}>
            <CurrencyRupeeIcon /> {item.price}
          </div>

                 {/* 🔴 Delete Button */}
                <button
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete this membership?"
                      )
                    ) {
                      handleDeleteMembership(item._id);
                    }
                  }}
                  className="btn blue "
                >
                  Delete
                </button>

        </div>
          )
        })
      }
      </div>

      <hr className="membershiphr" />
      <div className="membership3">
        <input
        value={inputField.months}
        onChange={(event)=>handleOnChange(event, "months")}
          className="membership3In"
          type="number"
          placeholder="Add No. of Months"
        />
        <input
        value={inputField.price}
        onChange={(event)=>handleOnChange(event, "price")}
          className="membership3In"
          type="number"
          placeholder="Add Price..."
        />
        <div onClick={()=>{handleAdMembership()}} className="btn green">ADD +</div>
      </div>
      <ToastContainer/>
    </div>
  );
};

export default Addmembership;
